import { useContext, useEffect, useRef } from "react";
import { observer } from "mobx-react-lite";
import { RootStoreContext } from "../../app/stores/rootStore";
import styled from "styled-components/macro";
import { useNavigate } from "react-router-dom";
import { signingYouInMessage } from "../../app/constant/loadingMessages";
import { Loader } from "../_components/Loader";
import { NotFound } from "@intouchhealth/cig-components";
import { ClockOutOfSync } from "../../app/constant/errorMessages";
import { HOME_URL } from "../../app/constant/routes";

const LoginPage = () => {
  const rootStore = useContext(RootStoreContext);
  const { completeLogin, redirectUrl, isClockOutOfSync } = rootStore.userStore;
  const didLogRef = useRef(false);
  let navigate = useNavigate();

  useEffect(() => {
    if (didLogRef.current === false) {
      didLogRef.current = true;
      completeLogin().then((success) => {
        if (success) {
          window.sessionStorage.removeItem("loginAttempts");
          navigate(redirectUrl);
          return;
        }
        if (!rootStore.userStore.isClockOutOfSync) {
          navigate(redirectUrl);
        }
      });
    }
  }, []); //eslint-disable-line react-hooks/exhaustive-deps

  if (isClockOutOfSync) {
    return (
      <Container>
        <NotFound
          errorData={ClockOutOfSync}
          onClick={() => {
            window.sessionStorage.removeItem("loginAttempts");
            navigate(HOME_URL);
          }}
        />
      </Container>
    );
  }

  return (
    <Container>
      <Loader message={signingYouInMessage} />
    </Container>
  );
};

const Container = styled.div`
  z-index: 10000;
  width: 100%;
`;

export default observer(LoginPage);
